<style lang="scss">
a {
  cursor: pointer;
  text-decoration: none;
  transition: color .2s;
  svg {
    transition: fill .2s;
    fill: currentColor;
  }
}

.subscription__more {
  text-align: center;
  margin: 10px 0 0;
  display: inline-block;
  position: relative;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: .3px;
  text-transform: uppercase;

  color: #f60;
  &:hover {
    color: #f30;
  }
  .svgicon {
    font-size: 20px;
    position: absolute;
    top: -4px;
    right: -28px;
  }
}
.svgicon {

}
[class*=" svgicon-"],
[class^=svgicon-] {
  display: inline-block;
  width: 1em;
  height: 1em;
  stroke-width: 0;
  stroke: currentColor;
  fill: currentColor;
}

.icon-wrapper {
  display: inline-block;
  vertical-align: middle;
  font-size: 30px;
  margin-right: 15px;
}
.payment-section {
  position: relative;
  background-color: #f2f2f2;
  padding: 30px 20px;
  &:before {
    content: '';
    top: 0; bottom: 0;
    left: 0; right: 0;
    border-radius: .4rem;
    position: absolute;
    background-color: #f2f2f2;
    z-index: -1;
  }
  &__footer {
    position: relative;
    section {
      position: relative;
      z-index: 2;
    }
    &:before {
      content: '';
      top: 0; bottom: 0;
      left: 0; right: 0;
      border-radius: .4rem;
      position: absolute;
      background-color: #fff;
      z-index: 1;
    }
  }
  &__header {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    padding-bottom: 50px;
    &-left {
      width: 67.53968254%;
      margin-right: 6.349206349%;
    }
    &-right {
      width: 32.46031746%;

      /* display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap; */

      vertical-align: top;
      display: table-cell;
      box-sizing: border-box;
      width: 300px;
    }
  }
  &__h1 {
    text-transform: uppercase;
    /* font-size: 40px; */
    font-size: 32px;
    line-height: 137.5%;
    font-weight: 400;
    margin: 0;
    margin-bottom: 20px;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    white-space: normal;
    max-height: 103px;
    overflow: hidden;
  }
  &__p {
    /* font-size: 20px; */
    font-size: 14px;
    margin: 0;
    font-weight: 300;
    line-height: 25px;
  }
  &__list {
    list-style: none;
    padding: 0;
    margin: -1px 0 20px 0;
    font-size: 0;
    white-space: nowrap;
    line-height: .8;
    &__i {
      display: inline-block;
      /* margin-right: 21px; */
      margin-right: 15px;
      vertical-align: top;
      span {
        display: block;
        &:first-child {
          /* font-size: 48px; */
          font-size: 32px;
          font-weight: 200;
        }
        &:last-child {
          /* font-size: 14px; */
          font-size: 12px;
          margin-top: 7px;
        }
      }
      &:last-child {
        display: inline-flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
      }
      .subscriptions-price {
        display: inline-flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }
      .subscriptions-discount {
        margin: 0 0 0 9px;
        display: inline-flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }
      span.subscriptions-discount {
        &-label {
          font-size: 12px;
          font-weight: 700;
          color: #fc363b;
          text-transform: uppercase;
        }
        &-text {
          font-size: 12px;
          font-weight: 700;
          color: #333;
          text-decoration: line-through;
        }
      }
    }
  }
  &__steps {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }
  &__step {
    margin-top: -50px;
    padding-top: 50px;
    position: relative;

    display: flex;
    flex-direction: row;
    justify-content: stretch;
    align-items: stretch;
    width: 100%;
    &-active &__bg {
      /* #fff */
      position: absolute;
      left: -30px; right: -30px;
      top: 50px; bottom: 0;
      z-index: 0;
      background-color: #fff;
    }
    &__container {
      border-top: 1px solid #dedede;
      padding: 0;

      display: flex;
      flex-direction: column;
      justify-content: stretch;
      align-items: stretch;
      width: 100%;

      position: relative;
      z-index: 1;
    }
    &-active &__header {
      max-height: 8000px;
    }
    &__header {
      min-height: 140px;
      height: 100%;
      max-height: 140px;
      position: relative;
      z-index: 1;

      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      &-left {
        padding-right: 6.349206349%;
        width: 76.19047619%;

        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
      }
      &-right {
        width: 23.80952381%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
      }
    }
  }
}

.step-title {
  text-transform: uppercase;
  font-size: 30px;
  line-height: 125%;
  display: inline-block;
  color: #333;
}

.pay-logos {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  [class*=" svgicon-"] {
    display: block;
    max-width: 60px;
    width: 100%;
    min-height: 30px;
  }
  [class*=" svgicon-"] + [class*=" svgicon-"] {
    margin-left: 15px;
  }
}

.pay-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: 580px;
  margin-bottom: 20px;
}
.card-do {
  &-title {
    margin: 0 0 34px 0;
    font-size: 16px;
  }
  &-add {
    margin-top: 15px;
  }
  &-sub {
    margin: 30px 0 0;
    min-height: 62px;
  }
  &-about {
    margin-top: 7px;
    font-size: 14px;
    color: #a6a6a6;
  }
}
</style>

<template lang="pug">
section.payment-section.col(v-if="sub")
  // is-loading(v-show="loading")
  header.payment-section__header
    .payment-section__header-left
      h1.payment-section__h1
        span АКТИВАЦИЯ ПОДПИСКИ «{{ sub.name }}»&nbsp;
        span.red-label(v-if="sub.label") {{ sub.label }}

      //- срок аренды - days: 30
      //- включен - isEnable: 1
      //- есть триал - isFreeTrial: 1
      //- скрытый доя всех - isHidden: 0
      //- нет комиссии для товаров - isNoComissionItems: 0
      //- нет комиссии для услуг - isNoComissionServices: 0
      //- нет комиссии для билетов - isNoComissionTickets: 1
      //- promocode: ""

      p.payment-section__p(v-if="sub.description") {{ sub.description }}
      p.payment-section__p(v-if="sub.required")
        span(style="color: red") *
        span  {{ sub.required }}
    .payment-section__header-right
      ul.payment-section__list
        li.payment-section__list__i(v-if="sub.isFreeTrial")
          span {{ sub.trialDays }}
          span дней<br/>пробного<br/>периода
        //- li.payment-section__list__i(v-if="sub.itemsCount > 0")
        //-   span {{ sub.itemsCount }}
        //-   span Товаров
        //- li.payment-section__list__i(v-if="sub.serviceCount > 0")
        //-   span {{ sub.serviceCount }}
        //-   span Услуг
        //- li.payment-section__list__i(v-if="sub.ticketsCount > 0")
        //-   span {{ sub.ticketsCount }}
        //-   span Билетов

        li.payment-section__list__i
          .subscription-price
            span {{ sub.price / 100 }}
            span бел.р./мес.
          .subscriptions-discount(v-if="sub.priceWithoutDiscount || sub.label")
            span.subscriptions-discount-label(v-if="sub.label") {{ sub.label }}
            span.subscriptions-discount-text(v-if="sub.priceWithoutDiscount"
              ) {{ sub.priceWithoutDiscount / 100 }} бел.р./мес.

      a.subscription__more(href="http://24bonus.by" target="_blank" rel="noopener")
        span Подробнее
        svg.svgicon.svgicon-rightward-sm
          use(xlink:href="~@/assets/img/svgicons.svg#svgicon-rightward-sm")
  section.payment-section__steps
    //- .payment-section__step(
      @click="() => { current = 0; }", :class="{ 'payment-section__step-active': current === 0 }")
      .payment-section__step__bg
      .payment-section__step__container
        .payment-section__step__header
          .payment-section__step__header-left
            .icon-wrapper(style="position:relative")
              svg.svgicon.svgicon-number
                use(xlink:href="~@/assets/img/svgicons.svg#svgicon-number-1")
            span.step-title ПЕРИОД ПОДПИСКИ

          .payment-section__step__header-right
            .row
              span 1 месяц за 14.9 бел.р.
              a ИЗМЕНИТЬ

    .payment-section__step(
      @click="() => { current = 1; }", :class="{ 'payment-section__step-active': current === 1 }")
      .payment-section__step__bg
      .payment-section__step__container
        .payment-section__step__header
          .payment-section__step__header-left
            .icon-wrapper(style="position:relative")
              svg.svgicon.svgicon-number
                use(xlink:href="~@/assets/img/svgicons.svg#svgicon-number-1")
            span.step-title ОПЛАТА
          //- .payment-section__step__header-right
            span any text or elements

        .payment-section__step__content(v-if="current === 1", style="padding-bottom: 60px;")
          template(v-if="addMoreCard || cards.length <= 0")
            button.button_primary-link(v-if="cards.length > 0"
              @click="back2cardSel", style="margin-bottom: 20px") ＜ Вернутся к выбору карты
            be-paid-form(@encrypted="encryptedCard" :public="params.public_key")
              .pay-logos
                svg.svgicon.svgicon-pci-dss
                  use(xlink:href="~@/assets/img/svgicons_payment.svg#pci-dss")
                svg.svgicon.svgicon-visa
                  use(xlink:href="~@/assets/img/svgicons_payment.svg#visa")
                svg.svgicon.svgicon-masrecard
                  use(xlink:href="~@/assets/img/svgicons_payment.svg#masrecard")

              .errors-with-card(:class="{ 'errors-with-card_show': errors.card.length }")
                template(v-for="ca in errors.card")
                  p {{ ca }}

          template(v-else)
            .pay-content
              .card-do-title Оплатите прикрепленной картой или используйте другую

              card-select(v-model="card", :options="cards")

              .card-do-add
                button.button_primary-link(@click="addCard") ОПЛАТИТЬ ДРУГОЙ КАРТОЙ

              .card-do-sub
                button.button.button_primary(@click="connect")
                  .default Подключить
                  //- .loading.loader-spinner(v-else)
                    i.icon.icon-spinner
                    span.loading-text Идет оплата
              .card-do-about
                span Подписка подразумевает ежемесячное автоматическое продление
                  | . Подключая подписку, вы принимаете условия&nbsp;
                  a(href="https://24guru.by/ru/pages/offer-contract", target="_blank",
                    rel="noopener noreferrer") пользовательского соглашения
                  | . Вы всегда можете отказаться от подписки в профиле пользователя.

  //- footer.payment-section__footer
    section
      span По всем вопросам о подписке и оплате обращайтесь
      a(href="tel:+375249707191") +37524-970-71-91
      .row
        a(href="mailto:support@megogo.net")
          svg.svgicon.svgicon-mail-support.icon
            use(xlink:href="~@/assets/img/svgicons.svg#svgicon-mail-support")
          span support@megogo.net
        a(href="https://telegram.me/megogonetbot")
          img(src="~@/assets/img/telegram.svg")
          span Telegram
        a(href="https://www.viber.com/support_megogo" target="_blank")
          img(src="~@/assets/img/viber.svg")
          span Viber
</template>

<script>
import API from '@/api/api';

import CardSelect from '@/components/card-select';

export default {
  name: 'SubsPaymentTabPage',
  components: {
    CardSelect,
  },
  props: {
    value: {
      type: String,
      default: '',
      required: false,
    },
    sub: {
      type: Object,
      default: () => (null),
      required: false,
    },
  },
  data: () => ({
    current: 1,
    cards: [],
    card: null,
    addMoreCard: false,

    loading: true,

    params: {},
    errors: {
      card: [],
    },
  }),
  mounted() {
    if (!this.sub) {
      this.$router.push({ path: '/subscribes/active' });
      return;
    }
    this.fetch();
    // console.log({ sub: this.sub });
  },
  methods: {
    async connect() {
      this.loading = true;
      await API.subscribes.post({
        user_card_id: this.card,
        package_id: this.sub.id,
      }, (e) => {
        console.error(e);
        global.alert('Ошибка при обработке оплаты с помощью привязаной карты');
        this.loading = false;
      });
      this.loading = false;
      this.$router.push({ path: '/subscribes/active' });
    },
    async fetch() {
      this.loading = true;
      this.params = await API.payment.tokenization_params();
      // console.log({ tk: this.params });

      const data = await API.getCards((error) => {
        console.log(error);
        this.loading = false;
      });
      this.cards = data.data;
      if (!this.cards.length) {
        this.addMoreCard = true;
      } else {
        this.card = this.cards[0].id;
      }
      this.loading = false;
    },
    addCard() {
      this.addMoreCard = true;
      this.errors.card = [];
    },
    back2cardSel() {
      this.addMoreCard = false;
      this.errors.card = [];
    },
    encryptedCard(e) {
      this.loading = true;
      this.errors.card = [];
      // todo: добавить метод подвязки карты
      API.cards.put({
        credit_card_last_4: e.credit_card_last_4,
        exp_month: e.encrypted_exp_month,
        exp_year: e.encrypted_exp_year,
        holder: e.encrypted_holder,
        number: e.encrypted_number,
        verification_value: e.encrypted_verification_value,
        payment_id: this.params.payment_id,
      }, (e) => {
        // console.dir(e);
        this.errors.card = (e && e.response && e.response.data && e.response.data.errors)
          || e.status;
        this.loading = false;
      }).then((card) => {
        if (this.cards.findIndex((e) => e.id === card.data.id) === -1) {
          this.cards.push({
            id: card.data.id,
            brand: card.data.brand,
            card_number: card.data.card_number,
            month: card.data.month,
            year: card.data.year,
          });
          this.card = card.data.id;
        }
        this.addMoreCard = false;
        this.loading = false;
      });
    },
  },
};
</script>
